var React = require('react');

function NounArrowGrey (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",{"type":"text/css"},"\n   \n    .fil0 {fill:#D6D6D6}\n   \n  ")),React.createElement("g",{"key":1},React.createElement("polygon",{"className":"fil0","points":"282,388 0,682 99,777 471,388 99,0 0,95 "}))]);
}

NounArrowGrey.defaultProps = {"height":"100px","width":"100px","fill":"#000000","xmlSpace":"preserve","version":"1.1","style":{"shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality"},"viewBox":"0 0 471 777","x":"0px","y":"0px","fillRule":"evenodd","clipRule":"evenodd"};

module.exports = NounArrowGrey;

NounArrowGrey.default = NounArrowGrey;
